import React, { Component } from "react";
import {
  Modal,
  Form,
  Col,
  Button,
  Card,
  Container,
  Row,
} from "react-bootstrap";
import * as Cookies from "es-cookie";
import { withRouter } from "react-router-dom";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import { withApollo } from "react-apollo";
import * as compose from "lodash.flowright";
import Select from "react-select";
import "./_userManagement.scss";

const ADD_LEVEL_EMPLOYEES = gql`
  mutation ($params: LevelEmployees) {
    addLevelEmployees(params: $params)
  }
`;

class EmployeeCreation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      branch_id: "",
      branchError: "",
      level_id: "",
      levelError: "",
      head_level_id: "",
      head_levelError: "",
      levelsData: [],
      headLevelsData: [],
      dataClear: 1,
      getEmployeesData: [],
      assignedEmployees: [],
      selectedEmployeData: [],
      loadingSpinner: 0,
      employeeDataSpinner: 0,
      currentStep: 0,
      submitError: "",
    };
  }

  addRow = () => {
    let array = this.state.selectedEmployeData;

    array.push({
      value: 0,
      label: "",
      employee_error: "",
      assign_employee_error: "Please assigned",
      is_deleted: false,
      del_lead_assign_id: 0,
      is_exist: false,
    });

    this.setState({
      selectedEmployeData: array,
    });
  };

  handleInputChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;



    if (name == "branch") {
      if (value != "" && value != "--Select Branch--") {
        this.setState({
          branch_id: value,
          branchError: "",
          level_id: "",
          levelError: "",
          head_level_id: "",
          head_levelError: "",
          headLevelsData: [],
          dataClear: 1,
          getEmployeesData: [],
          selectedEmployeData: [],
          employeeDataSpinner: 1,
        });
        this.getLevelsData();
      } else {
        this.setState({
          branch_id: "",
          branchError: "",
          level_id: "",
          levelError: "",
          head_level_id: "",
          head_levelError: "",
          headLevelsData: [],
          dataClear: 1,
          getEmployeesData: [],
          selectedEmployeData: [],
          levelsData: [],
        });
      }
    }
    if (name == "level") {
      if (value != "") {
        this.setState({
          level_id: value,
          levelError: "",
          head_level_id: "",
          head_levelError: "",
          dataClear: 1,
          getEmployeesData: [],
          selectedEmployeData: [],
        });
        this.getHeadEmployees(value);
      } else {
        this.setState({
          level_id: "",
          levelError: "",
          head_level_id: "",
          head_levelError: "",
          dataClear: 1,
          getEmployeesData: [],
          selectedEmployeData: [],
        });
      }
    }
    if (name == "levelHead") {
      this.setState({
        head_level_id: value,
        head_levelError: "",
        dataClear: 1,
        getEmployeesData: [],
        selectedEmployeData: [],
      });
    }
  };

  handleGetEmployes = (e) => {
    e.preventDefault();
    if (
      this.state.branch_id == "" ||
      this.state.branch_id == "--Select Branch--"
    ) {
      this.setState({ branchError: "Please Select Branch" });
      return "";
    }
    if (
      this.state.level_id == "" ||
      this.state.level_id == "--Select Level--"
    ) {
      this.setState({ levelError: "Please Select Level" });
      return "";
    }
    if (
      this.state.head_level_id == "" ||
      this.state.head_level_id == "--Select Level Head--"
    ) {
      this.setState({ head_levelError: "Please Select Level Head" });
      return "";
    }
    this.setState({ currentStep: 1 });
    this.getTotalEmployees();
    this.getLevelEmployees();
  };

  getLevelsData = async (val) => {
    const result = await this.props.client.query({
      query: gql`
        query ($id: Int) {
          getLevels(id: $id) {
            level_id
            level_name
          }
        }
      `,
      variables: {
        id: 0,
      },
      fetchPolicy: "network-only",
    });

    if (result.data.getLevels.length > 0) {
      let data = result.data.getLevels;
      this.setState({ levelsData: data, employeeDataSpinner: 0 });
    } else {
      this.setState({ levelsData: [], employeeDataSpinner: 0 });
    }
  };

  getHeadEmployees = async (val) => {
    const result = await this.props.client.query({
      query: gql`
        query ($institute_id: Int, $branch_id: Int, $level_id: Int) {
          getHeadEmployeesDetails(
            institute_id: $institute_id
            branch_id: $branch_id
            level_id: $level_id
          ) {
            employee_id
            employee_name
          }
        }
      `,
      variables: {
        institute_id: parseInt(Cookies.get("institutionid")),
        branch_id: parseInt(this.state.branch_id),
        level_id: parseInt(val) - 1,
      },
      fetchPolicy: "network-only",
    });

    if (result.data.getHeadEmployeesDetails.length > 0) {
      let data = result.data.getHeadEmployeesDetails;
      this.setState({ headLevelsData: data });
    } else {
      this.setState({ headLevelsData: [] });
    }
  };

  getTotalEmployees = async (val) => {
    const result = await this.props.client.query({
      query: gql`
        query ($institute_id: Int, $branch_id: Int) {
          getLeadManagementEmployees(
            institute_id: $institute_id
            branch_id: $branch_id
          ) {
            employee_id
            employee_name
            assigned_status
            emp_mobile
          }
        }
      `,
      variables: {
        institute_id: parseInt(Cookies.get("institutionid")),
        branch_id: parseInt(this.state.branch_id),
      },
      fetchPolicy: "network-only",
    });

    if (result.data.getLeadManagementEmployees.length > 0) {
      let data = result.data.getLeadManagementEmployees;
      let unAssignedEmp = [];
      let assignedEmp = [];

      if (data.filter((a) => a.assigned_status == "assigned").length > 0) {
        let obj = {
          label: "Select...",
          value: 0,
        };
        assignedEmp.push(obj);

        data
          .filter((a) => a.assigned_status == "assigned")
          .map((item) => {
            assignedEmp.push({
              label: `${item.employee_name}(${item.emp_mobile})`,
              value: item.employee_id,
            });
          });
      }
      if (data.filter((a) => a.assigned_status == "unassigned").length > 0) {
        let obj = {
          label: "Select...",
          value: 0,
        };
        unAssignedEmp.push(obj);

        data
          .filter((a) => a.assigned_status == "unassigned")
          .map((item) => {
            unAssignedEmp.push({
              label: `${item.employee_name}(${item.emp_mobile})`,
              value: item.employee_id,
            });
          });
      }

      this.setState({
        getEmployeesData: unAssignedEmp,
        assignedEmployees: assignedEmp,
      });
    } else {
      this.setState({ getEmployeesData: [], assignedEmployees: [] });
    }
  };

  getLevelEmployees = async (val) => {
    this.setState({ selectedEmployeData: [], employeeDataSpinner: 1 });
    const result = await this.props.client.query({
      query: gql`
        query ($institute_id: Int, $branch_id: Int, $head_employee_id: Int) {
          getLevelEmployeeDetails(
            institute_id: $institute_id
            branch_id: $branch_id
            head_employee_id: $head_employee_id
          ) {
            employee_id
            employee_name
            emp_mobile
          }
        }
      `,
      variables: {
        institute_id: parseInt(Cookies.get("institutionid")),
        branch_id: parseInt(this.state.branch_id),
        head_employee_id: parseInt(this.state.head_level_id),
      },
      fetchPolicy: "network-only",
    });

    if (result.data.getLevelEmployeeDetails.length > 0) {
      let data = result.data.getLevelEmployeeDetails;
      let levelEmployees = [];
      data.map((item) => {
        let newObj = {
          value: item.employee_id,
          label: `${item.employee_name}(${item.emp_mobile})`,
          is_deleted: false,
          del_lead_assign_id: 0,
          is_exist: true,
          employee_error: "",
          assign_employee_error: "Please assigned",
        };
        levelEmployees.push(newObj);
      });
      this.setState({
        selectedEmployeData: levelEmployees,
        employeeDataSpinner: 0,
      });
    } else {
      this.setState({
        selectedEmployeData: [
          {
            value: 0,
            label: "",
            employee_error: "",
            is_deleted: false,
            del_lead_assign_id: 0,
            is_exist: false,
            assign_employee_error: "Please assigned",
          },
        ],
        employeeDataSpinner: 0,
      });
    }
  };

  handleChange = (e, i) => {
    let val = e.value == undefined ? e.target.value : e.value;
    let name = e.value == undefined ? e.target.name : e.label;
    let array1 = [];

    if (name != "assignEmp") {
      this.state.selectedEmployeData.map((item, index) => {
        if (i == index) {
          if (val != null || val != 0) {
            const filteredEmployees = this.state.getEmployeesData.filter(
              (a) => a.value == val,
            );
            array1.push({
              value: `${val}`,
              label: `${filteredEmployees[0].label}`,
              is_deleted: false,
              del_lead_assign_id: 0,
              is_exist: false,
            });
          } else {
            array1.push({ value: 0, label: "Select..." });
          }
        } else {
          array1.push({ ...item });
        }
      });
    } else {
      this.state.selectedEmployeData.map((item, index) => {
        if (i == index) {
          if (val != 0) {
            array1.push({
              ...item,
              del_lead_assign_id: val,
              assign_employee_error: "",
            });
          } else {
            array1.push({
              ...item,
              del_lead_assign_id: 0,
              assign_employee_error: "Please assigned",
            });
          }
        } else {
          array1.push({ ...item });
        }
      });
    }

    this.setState({ selectedEmployeData: array1 });
  };

  handleDelete = (i) => {
    let array1 = [];
    let is_delete = false;

    this.state.selectedEmployeData.map((item, index) => {
      if (i == index) {
        if (item.is_exist) {
          array1.push({ ...item, is_deleted: true });
        } else {
          is_delete = true;
        }
      } else {
        array1.push({ ...item });
      }
    });



    if (is_delete) {
      array1 = array1.filter((item, index) => index != i);
    }
    this.setState({ selectedEmployeData: array1 });
  };

  handleSubmit = () => {
    let stopExecuting = false;
    this.state.selectedEmployeData.some((obj, i) => {

      let errorUpdate = this.state.selectedEmployeData;

      if (obj.value == null || obj.label == "") {
        errorUpdate[i] = { ...obj, employee_error: "Please Select Employee" };
        this.setState({ selectedEmployeData: errorUpdate });
        stopExecuting = true;
        return true;
      }
      if (obj.is_deleted === true && obj.del_lead_assign_id == 0) {
        errorUpdate[i] = { ...obj, assign_employee_error: "Please Select" };
        this.setState({ selectedEmployeData: errorUpdate });
        stopExecuting = true;
        return true;
      }
    });

    if (stopExecuting) {
      return "";
    }

    const updatedSelectedEmployeData = this.state.selectedEmployeData.map(
      (item) => ({
        employee_id: parseInt(item.value),
        is_deleted: item.is_deleted,
        del_lead_assign_id: parseInt(item.del_lead_assign_id),
        is_exist: item.is_exist,
      }),
    );

    const params = {
      institute_id: parseInt(Cookies.get("institutionid")),
      branch_id: parseInt(this.state.branch_id),
      level_id: parseInt(this.state.level_id),
      head_employee_id: parseInt(this.state.head_level_id),
      inserted_by: parseInt(Cookies.get("id")),
      employeDetails: updatedSelectedEmployeData,
    };

    this.setState({
      loadingSpinner: 1,
    });

    this.addLevelEmployees(params).catch((error) => {
      this.setState({
        submitError: error.graphQLErrors.map((x) => x.message),
        loadingSpinner: 0,
      });
      console.error(
        "ERR =>",
        error.graphQLErrors.map((x) => x.message),
      );
    });
  };

  addLevelEmployees = async (params) => {
    await this.props.addLevelEmployees({
      variables: {
        params,
      },
      update: (store, { data }) => {
        if (data.addLevelEmployees) {
          this.setState({
            loadingSpinner: 0,
            currentStep: 5,
          });
          setTimeout(() => {
            this.setState({
              branch_id: "", level_id: "", head_level_id: "",
              levelsData: [], headLevelsData: [], dataClear: 1,
              getEmployeesData: [], assignedEmployees: [],
              selectedEmployeData: [], currentStep: 0,
              submitError: "", loadingSpinner: 0, employeeDataSpinner: 0,
            });
          }, 2000);
        }
      },
    });
  };

  render() {
    const FIN = {
      card: { background: "#fff", borderRadius: 16, boxShadow: "0 4px 24px rgba(0,0,0,0.05)", overflow: "visible", border: "1px solid #e2e8f0" },
      cardHeader: { background: "#ffffff", padding: "20px 24px", display: "flex", alignItems: "center", gap: 14, borderBottom: "1px solid #f1f5f9", flexWrap: "wrap" },
      iconWrapper: { width: 38, height: 38, borderRadius: 10, background: "#f5f3ff", border: "1px solid #ddd6fe", display: "flex", alignItems: "center", justifyContent: "center", color: "#7c3aed", fontSize: 16, flexShrink: 0 },
      cardTitleText: { display: "flex", flexDirection: "column", textAlign: "left" },
      cardTitle: { color: "#0f172a", fontWeight: 700, fontSize: 16, margin: 0, letterSpacing: "-0.01em" },
      cardSubtitle: { color: "#64748b", fontSize: 12, fontWeight: 500, marginTop: 2 },
      label: { fontWeight: 600, fontSize: 13, color: "#475569", marginBottom: 6 },
      input: { borderRadius: 9, border: "1px solid #e2e8f0", padding: "9px 12px", fontSize: 13, height: 42, color: "#0f172a" },
      btnPrimary: { display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 7, background: "#7c3aed", color: "#fff", border: "none", borderRadius: 9, padding: "10px 16px", fontSize: 13, fontWeight: 600, cursor: "pointer", height: 42 },
    };
    return (
      <section>
        <Container fluid className="px-0">
          <Row>
            <Col xl={12} lg={12} md={12} sm={12}>
              <Card style={FIN.card}>
                <div style={FIN.cardHeader}>
                  <div style={FIN.iconWrapper}><i className="fal fa-users-cog" /></div>
                  <div style={FIN.cardTitleText}>
                    <h6 style={FIN.cardTitle}>User Management</h6>
                    <span style={FIN.cardSubtitle}>Assign employees to branch hierarchy levels</span>
                  </div>
                </div>
                <Card.Body style={{ padding: "28px" }}>
                  <Form>
                    <Form.Row>
                      <Form.Group
                        as={Col}
                        lg={3}
                        md={12}
                        sm={12}
                        controlId="SelectBranch"
                      >
                        <Form.Label style={FIN.label}>
                          Branch
                        </Form.Label>
                        <Form.Control
                          as="select"
                          name="branch"
                          onChange={this.handleInputChange}
                          value={this.state.branch_id}
                          style={FIN.input}
                        >
                          <option>--Select Branch--</option>
                          {this.props.globals.globalBranches.map(
                            (branchData) => (
                              <option value={branchData.id}>
                                {branchData.branch_name}
                              </option>
                            ),
                          )}
                        </Form.Control>
                        <Form.Text
                          className="form-text text-danger"
                          type="invalid"
                        >
                          {this.state.branchError}
                        </Form.Text>
                      </Form.Group>

                      <Form.Group
                        as={Col}
                        lg={3}
                        md={12}
                        sm={12}
                        controlId="SelectBranch"
                      >
                        <Form.Label style={FIN.label}>
                          Levels
                        </Form.Label>
                        <Form.Control
                          as="select"
                          name="level"
                          onChange={this.handleInputChange}
                          value={this.state.level_id}
                          style={FIN.input}
                        >
                          <option>--Select Level--</option>
                          {this.state.levelsData.map((leveldata) => (
                            <option
                              key={leveldata.level_id}
                              value={leveldata.level_id}
                            >
                              {leveldata.level_name}
                            </option>
                          ))}
                        </Form.Control>
                        <Form.Text
                          className="form-text text-danger"
                          type="invalid"
                        >
                          {this.state.levelError}
                        </Form.Text>
                      </Form.Group>

                      <Form.Group
                        as={Col}
                        lg={3}
                        md={12}
                        sm={12}
                        controlId="SelectBranch"
                      >
                        <Form.Label style={FIN.label}>
                          Level Head
                        </Form.Label>
                        <Form.Control
                          as="select"
                          name="levelHead"
                          onChange={this.handleInputChange}
                          value={this.state.head_level_id}
                          style={FIN.input}
                        >
                          <option>--Select Level Head--</option>
                          {this.state.headLevelsData.map((headdata) => (
                            <option
                              key={headdata.employee_id}
                              value={headdata.employee_id}
                              selected={
                                this.state.head_level_id == headdata.employee_id
                                  ? true
                                  : false
                              }
                            >
                              {headdata.employee_name}
                            </option>
                          ))}
                        </Form.Control>
                        <Form.Text
                          className="form-text text-danger"
                          type="invalid"
                        >
                          {this.state.head_levelError}
                        </Form.Text>
                      </Form.Group>

                      <Form.Group
                        as={Col}
                        lg={3}
                        md={12}
                        sm={12}
                        controlId="SelectBranch"
                      >
                        <div className="mt-4">
                          <button
                            className="getEmployeeDetails mt-1"
                            onClick={this.handleGetEmployes}
                            style={FIN.btnPrimary}
                          >
                            GET EMPLOYEES
                          </button>
                        </div>
                      </Form.Group>
                    </Form.Row>
                  </Form>

                  {this.state.employeeDataSpinner == 1 ? (
                    <>
                      <style>{`@keyframes ecShim{0%{background-position:-800px 0}100%{background-position:800px 0}}.ec-shim{background:linear-gradient(90deg,#f0f0f0 25%,#e0e0e0 50%,#f0f0f0 75%);background-size:800px 100%;animation:ecShim 1.4s infinite linear;border-radius:6px;}`}</style>
                      <Row className="mt-3">
                        {[0, 1, 2, 3].map((i) => (
                          <Col lg={6} md={6} sm={6} key={i} className="mb-3">
                            <div className="ec-shim" style={{ width: 90, height: 14, marginBottom: 8 }} />
                            <div className="ec-shim" style={{ width: 200, height: 38, borderRadius: 8 }} />
                          </Col>
                        ))}
                      </Row>
                    </>
                  ) : (
                    ""
                  )}
                  <Row>
                    {this.state.selectedEmployeData.length > 0
                      ? this.state.selectedEmployeData.map((item, i) => (
                          <>
                            <Col lg={6} md={6} sm={6}>
                              <div className="row">
                                <Form.Group
                                  controlId="SelectClass"
                                  style={{ marginLeft: "15px" }}
                                >
                                  <Form.Label style={FIN.label}>
                                    Employee
                                  </Form.Label>
                                  <div className="row">
                                    <div
                                      className="col-md-12 col-sm-12"
                                      style={{ width: "200px" }}
                                    >
                                      <Select
                                        options={this.state.getEmployeesData}
                                        onChange={(e) =>
                                          this.handleChange(e, i)
                                        }
                                        name="employee"
                                        isDisabled={
                                          item.is_exist == false ? false : true
                                        }
                                        value={
                                          item.value
                                            ? {
                                                value: item.value,
                                                label: item.label,
                                              }
                                            : 0
                                        }
                                      />
                                    </div>
                                  </div>
                                  <Form.Text
                                    className="form-text text-danger"
                                    type="invalid"
                                  >
                                    <span className="text-danger">
                                      {item.employee_error}
                                    </span>
                                  </Form.Text>
                                </Form.Group>
                                {item.is_deleted ? (
                                  <Form.Group controlId="SelectClass">
                                    <Form.Label style={FIN.label}>
                                      Assign To
                                    </Form.Label>
                                    <Form.Control
                                      as="select"
                                      name="assignEmp"
                                      onChange={(e) => this.handleChange(e, i)}
                                      style={{ width: "180px" }}
                                    >
                                      {/* <option value="0" >--Select AssignEmp--</option> */}
                                      {this.state.assignedEmployees.map(
                                        (data) => (
                                          <option
                                            key={data.value}
                                            value={data.value}
                                          >
                                            {data.label}
                                          </option>
                                        ),
                                      )}
                                    </Form.Control>
                                    <Form.Text
                                      className="form-text text-danger"
                                      type="invalid"
                                    >
                                      <span className="text-danger">
                                        {item.assign_employee_error}
                                      </span>
                                    </Form.Text>
                                  </Form.Group>
                                ) : (
                                  ""
                                )}
                                {!item.is_deleted ? (
                                  <div
                                    className="deleteButton col-sm-3"
                                    style={{
                                      marginLeft: "-13px",
                                      marginTop: "27px",
                                    }}
                                  >
                                    <button
                                      onClick={() => this.handleDelete(i)}
                                      className={`btn btn-white text-danger`}
                                    >
                                      <i className="far fa-trash-alt" />
                                    </button>
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                            </Col>
                          </>
                        ))
                      : ""}
                  </Row>

                  {this.state.selectedEmployeData.length > 0 ? (
                    <div>
                      <button
                        className="btn add_btn"
                        type="button"
                        onClick={this.addRow}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="currentColor"
                          className="bi bi-plus"
                          viewBox="0 0 16 16"
                        >
                          <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                        </svg>
                      </button>
                    </div>
                  ) : (
                    ""
                  )}
                  {this.state.selectedEmployeData.length > 0 ? (
                    <Row>
                      <Col className="text-center">
                        <button
                          className="creationSubmit"
                          onClick={this.handleSubmit}
                          style={FIN.btnPrimary}
                        >
                          {this.state.loadingSpinner == 1 ? (
                            <span className="spinner-border spinner-border-sm"></span>
                          ) : (
                            ""
                          )}
                          CREATE EMPLOYEE
                        </button>
                        <div>
                          {this.state.currentStep == 5 ? (
                            <p className="text-success">
                              Employees assigned Successfully
                            </p>
                          ) : (
                            <Form.Text
                              className="form-text text-danger mb-2"
                              style={{ textAlign: "center" }}
                            >
                              {this.state.submitError}
                            </Form.Text>
                          )}
                        </div>
                      </Col>
                    </Row>
                  ) : (
                    ""
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
    );
  }
}

export default withRouter(
  withApollo(
    compose(
      graphql(ADD_LEVEL_EMPLOYEES, {
        name: "addLevelEmployees",
      }),
    )(EmployeeCreation),
  ),
);
